/* eslint-disable jsx-a11y/no-access-key */
import React from 'react'
import { useTranslation } from 'react-i18next'
import config from '../../../../config'
import { FormControl, Input, useTheme } from '@material-ui/core'
import { useSelector } from 'react-redux'
import BenchmarkSelector from '../../BenchmarkSelector'
import { handlePromptValueToggle } from '../../../../utils'

const RightSection = ({
  benchmarkSelectWrapperRef,
  benchmarkList,
  useBenchmarkList,
  currentCard,
  handleTextTypeChange,
  promptForOptimization,
  setPromptForOptimization,
  setPromptValues,
  promptValues,
  handleOurAi,
  translatedText
}) => {
  const { t} = useTranslation()
  const { theme: { bgColors, colors, borderColors } } = useTheme()

  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const isWhite = themeState === config.THEMES_MODES.CONTRAST_LIGHT

  return (
    <div className="col-lg-4 col-md-12" style={{ height: '100%' }}>
      <div className="p-3 pb-5" style={{
        backgroundColor: bgColors.bgPrimary100,
        borderRadius: '8px',
        height: '100%',
        overflowY: 'auto',
        border: `1px solid ${borderColors.borderPrimary200}`,
      }}>
        <h6 className="fw-bold mb-3" style={{ color: colors.colorText }}>{t('ai_gen_basic-settings')}</h6>
        <div>
          <label className="font-weight-bold small m-0"
                 style={{ color: colors.colorText }} htmlFor="ai-gen-optimization-input" id="ai-gen-optimization-input-label">{t('ai_gen_prompt')}</label>
          <FormControl fullWidth style={{
            flex: 1,
            border: `1px solid ${borderColors.borderPrimary200}`,
            backgroundColor: bgColors.bgPrimary0,
            borderRadius: '7px',
            padding: '0 10px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
          }}>
            <Input
              placeholder={t('ai_gen_optimization-placeholder')}
              multiline
              rows="4"
              value={promptForOptimization}
              onChange={(e) => {
                setPromptForOptimization(e.target.value)
              }}
              disableUnderline
              inputProps={{
                id: 'ai-gen-optimization-input',
                'aria-labelledby': 'ai-gen-optimization-input-label',
                accessKey: config.accessKeys.genOptInput,
                tabIndex: config.tabIndexes.genOptInput,
                style: {
                  color: colors.colorText,
                }
              }}
            />
          </FormControl>
          <hr className="my-4" style={{ borderTop: `1px solid ${borderColors.borderPrimary200}` }}/>
        </div>
        <div>
          <div className="mb-2 d-flex align-items-center justify-content-between" ref={benchmarkSelectWrapperRef}>
            <div id="ai-gen-text-type-label" style={{
              whiteSpace: 'nowrap',
              fontSize: '0.95rem',
              fontWeight: 'bold',
              color: isContrast ? colors.colorText : colors.colorMutedText
            }}>
              {t('ai_gen_text_type')}
            </div>
            <FormControl
              variant="outlined"
              style={{
                width: '45%',
                backgroundColor: bgColors.bgPrimary600,
                borderRadius: 4,
                height: 30,
                justifyContent: 'center',
              }} tabIndex={config.tabIndexes.genTextTypeSelect}
            >
              <BenchmarkSelector
                benchmarkList={benchmarkList}
                useBenchmarkList={useBenchmarkList}
                handleOnTextTypeChange={handleTextTypeChange}
                accessKey={config.accessKeys.benchmarkSelectionTop}
                ariaLabel={t('ai_gen_text_type')}
                labelId="ai-gen-text-type-label"
                styleMain={{
                  color: colors.colorPrimary50,
                  fontSize: '0.875rem',
                  height: '100%',
                  fontWeight: 'bold',
                }}
                stylePaper={{
                  backgroundColor: bgColors.bgPrimary600,
                  color: colors.colorPrimary50
                }}
                styleArrow={{ color: colors.colorPrimary50 }}
              />
            </FormControl>
          </div>
          <hr className="my-4" style={{ borderTop: `1px solid ${borderColors.borderPrimary200}` }}/>
        </div>
        <div className="row">
          {Array.isArray(currentCard?.shared_settings?.optimization?.settings) && currentCard.shared_settings.optimization.settings.map((setting, settIndex) => (
            <div className="col-12 mb-2" key={setting.name}>
              <label className="font-weight-bold small d-block mb-2"
                     style={{ color: colors.colorText }}>{t(setting.name)}</label>
              <div className="d-flex flex-wrap" style={{ gap: '0.5rem' }}>
                {setting.values.map((value, valIndex) => {
                  const isSelected = promptValues[setting.name] === value.id
                  const flatIndex = currentCard.shared_settings.optimization.settings
                    .slice(0, settIndex)
                    .reduce((acc, s) => acc + s.values.length, 0) + valIndex
                  return (
                    <div onClick={() => setPromptValues(prev => handlePromptValueToggle(prev, setting.name, value.id))}
                         tabIndex={config.tabIndexes.genSelections[flatIndex] ?? -1}>
                      <button key={value.id} type="button"
                              className={`btn px-2 py-1 ${isSelected ? 'text-white' : ''}`} style={{
                        backgroundColor: isSelected ? bgColors.bgAiBtnSelected : bgColors.bgAiBtn,
                        color: isSelected ? colors.colorWhite : isWhite ? colors.colorWhite : isContrast ? colors.colorText : colors.colorMutedText,
                        fontSize: '0.75rem',
                        transition: 'background-color 0.2s ease, color 0.2s ease',
                        boxShadow: isSelected ? '0 0 5px rgba(0, 0, 0, 0.161)' : 'none',
                        border: isSelected ? `1px solid ${borderColors.borderPrimary200}` : 'none'
                      }}
                              onMouseEnter={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.backgroundColor = bgColors.bgAiBtnHover
                                  e.currentTarget.style.color = colors.colorWhite
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.backgroundColor = bgColors.bgAiBtn
                                  e.currentTarget.style.color = isWhite ? colors.colorWhite : isContrast ? colors.colorText : colors.colorMutedText
                                }
                              }}>
                        {t(value.text)}
                      </button>
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
        <hr className="my-4 pb-2" style={{ borderTop: `1px solid ${borderColors.borderPrimary200}` }}/>
        <div onClick={() => { handleOurAi(translatedText, true) }} tabIndex={config.tabIndexes.genOptBtn}
             className="w-100 d-flex justify-content-center align-items-center">
          <button className="btn" style={{
            backgroundColor: bgColors.bgProgress100,
            color: colors.colorBtnText,
            borderRadius: '8px',
            border: `1px solid ${borderColors.borderPrimary200}`
          }} title={t('ai_gen_optimization_button')} accessKey={config.accessKeys.genOptimize}>
            {t('ai_gen_optimization_button')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default RightSection